import { Instagram, Mail, Dumbbell, ShoppingBag, HeartPulse, Sprout } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-[#E5E2D9] bg-[#F7F5F0]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-12 md:py-16 grid md:grid-cols-12 gap-10 md:gap-16">
        <div className="md:col-span-5">
          <div className="font-serif-display text-3xl font-medium text-[#2D372B]">Coach Sanjay</div>
          <p className="mt-3 text-sm text-[#5C665A] max-w-sm">
            Physical & mental wellness. Nutrition. Bootcamps. One coach who
            treats them all as the same practice.
          </p>
        </div>
        <div className="md:col-span-3">
          <div className="overline mb-4">Practice</div>
          <ul className="space-y-2 text-sm text-[#5C665A]">
            <li><a href="/#destinations" className="hover:text-[#2D372B] transition-colors">Destinations</a></li>
            <li><a href="/#collections" className="hover:text-[#2D372B] transition-colors">Collections</a></li>
            <li><a href="/calendar" className="hover:text-[#2D372B] transition-colors">Wellness Calendar</a></li>
            <li><a href="/journal" className="hover:text-[#2D372B] transition-colors">Journal</a></li>
            <li><a href="/train" className="hover:text-[#2D372B] transition-colors">Train Before You Travel</a></li>
            <li><a href="/retreats" className="hover:text-[#2D372B] transition-colors">Corporate Retreats</a></li>
            <li><a href="/coaching" className="hover:text-[#2D372B] transition-colors">Coaching &amp; Bootcamps</a></li>
            <li><a href="/coaching#contact" className="hover:text-[#2D372B] transition-colors">Contact</a></li>
          </ul>
        </div>
        <div className="md:col-span-4">
          <div className="overline mb-4">Elsewhere</div>
          <div className="flex items-center gap-4 text-[#5C665A]">
            <a href="https://www.instagram.com/transformwithssanjayy?igsh=MWY0OXpob2JhcXR1Yg==" target="_blank" rel="noopener noreferrer" className="p-2 rounded-full border border-[#E5E2D9] hover:bg-white transition-colors" aria-label="Instagram"><Instagram size={16} /></a>
            <a href="/coaching#contact" className="p-2 rounded-full border border-[#E5E2D9] hover:bg-white transition-colors" aria-label="Email"><Mail size={16} /></a>
          </div>
          <div className="mt-4 flex flex-wrap gap-3">
            <a
              href="/plan"
              data-testid="footer-workout-plan-link"
              className="inline-flex items-center gap-2 text-sm text-[#5C665A] px-4 py-2 rounded-full border border-[#E5E2D9] hover:bg-white hover:text-[#2D372B] transition-colors"
            >
              <Dumbbell size={14} /> Free 7-Day Workout Plan
            </a>
            <a
              href="/wellness-quiz"
              data-testid="footer-wellness-quiz-link"
              className="inline-flex items-center gap-2 text-sm text-[#5C665A] px-4 py-2 rounded-full border border-[#E5E2D9] hover:bg-white hover:text-[#2D372B] transition-colors"
            >
              <HeartPulse size={14} /> Free Wellness Assessment
            </a>
            <a
              href="/suppliers"
              data-testid="footer-suppliers-link"
              className="inline-flex items-center gap-2 text-sm text-[#5C665A] px-4 py-2 rounded-full border border-[#E5E2D9] hover:bg-white hover:text-[#2D372B] transition-colors"
            >
              <Sprout size={14} /> Supply Coffee to Us
            </a>
            <a
              href="/corporate"
              data-testid="footer-corporate-link"
              className="inline-flex items-center gap-2 text-sm text-[#5C665A] px-4 py-2 rounded-full border border-[#E5E2D9] hover:bg-white hover:text-[#2D372B] transition-colors"
            >
              <ShoppingBag size={14} /> Corporate Wellness
            </a>
            <a
              href="https://www.trainerize.me/profile/transformwithsanjay/YourTransformationalZone.0/?_gl=1*1aafi3j*_gcl_au*MTE4Njk1ODI0Ny4xNzgyODc1MzczLjEzNjQ0MTQxNzcuMTc4Mzk0NDM2NS4xNzgzOTQ2MDI0*_ga*MjY2ODY5NDUxLjE3NTc5OTE0MzU.*_ga_1ZRCE9XKNK*czE3ODM5NDQzMDgkbzExMSRnMSR0MTc4Mzk0NjE1NyRqNTkkbDAkaDAkZGw5TGhZMklnVWRDODM4cElEVXNDWnB5MTdrRDA0WUtPOUE."
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-trainerize-link"
              className="inline-flex items-center gap-2 text-sm text-[#5C665A] px-4 py-2 rounded-full border border-[#E5E2D9] hover:bg-white hover:text-[#2D372B] transition-colors"
            >
              <Dumbbell size={14} /> Train with me on Trainerize
            </a>
            <a
              href="https://store.trainergoesonline.com/sale/sanjaybhandari/"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-store-link"
              className="inline-flex items-center gap-2 text-sm text-[#5C665A] px-4 py-2 rounded-full border border-[#E5E2D9] hover:bg-white hover:text-[#2D372B] transition-colors"
            >
              <ShoppingBag size={14} /> More About Me
            </a>
          </div>
        </div>
      </div>
      <div className="border-t border-[#E5E2D9] py-6 px-6 md:px-12">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-[#5C665A]">
          <div>© {new Date().getFullYear()} Coach Sanjay. All rights reserved.</div>
          <div>Made with care.</div>
        </div>
      </div>
    </footer>
  );
}
